import { render } from "./GovernorateEditing.vue?vue&type=template&id=071a3532&ts=true"
import script from "./GovernorateEditing.vue?vue&type=script&lang=ts"
export * from "./GovernorateEditing.vue?vue&type=script&lang=ts"

import exportComponent from "/var/www/html/lmd-admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__